var canUseDom = function canUseDom() {
  return Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
};

export default canUseDom;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/portal/dist/esm/utils/canUseDom.js
// module id = 724
// module chunks = 0